<template>
    <Card :title="$route.meta.title" dis-hover>
        <Form inline @keydown.enter.native.prevent="refreshGetTableData">
            <FormItem>
                <depart-sel v-model="query.department.id" placeholder="选择检测单位" :departmentType="1" width="200px" clearable=""></depart-sel>
            </FormItem>
            <FormItem>
              <tester-sel v-model="query.tester.id" :departmentId="query.department.id" :withoutDepart="false" width="200px" placeholder="请选择检测人员"></tester-sel>
            </FormItem>
            <FormItem>
                <Select v-model="query.dataType" placeholder="设备类型" style="width:200px;" clearable="">
                    <Option :value="1">烟度计</Option>
                    <Option :value="2">计时器</Option>
                    <Option :value="3">震动转速分析仪</Option>
                    <Option :value="4">滤光片</Option>
                    <Option :value="5">空盒气压表</Option>
                </Select>
            </FormItem>
            <FormItem>
                <Button type="primary" icon="ios-search" @click="refreshGetTableData">查询</Button>
            </FormItem>
            <Button type="success" icon="md-add" @click="handleOperation(null,'ADD')">
                添加
            </Button>
        </Form>

        <Table :loading="tableLoading" :columns="tableColumns" :data="tableList">
            <template slot-scope="{row}" slot="department">
                {{row.department.departmentName}}
            </template>
            <template slot-scope="{row}" slot="tester">
              {{row.tester&&row.tester.name}}
            </template>
            <template slot-scope="{row}" slot="dataType">
                {{getTypeName(row.dataType)}}
            </template>
            <template slot-scope="{row}" slot="communicationMode">
                {{modeArr[row.communicationMode]}}
            </template>
            <!--<template slot-scope="{row}" slot="opacimeter">
                型号：{{row.opacimeterType}}<br>
                编号：{{row.opacimeterNo}}<br>
                厂家：{{row.opacimeterManu}}
            </template>
            <template slot-scope="{row}" slot="timer">
                型号：{{row.timerType}}<br>
                编号：{{row.timerNo}}<br>
                厂家：{{row.timerManu}}
            </template>
            <template slot-scope="{row}" slot="vsa">
                型号：{{row.vsaType}}<br>
                编号：{{row.vsaNo}}<br>
                厂家：{{row.vsaManu}}
            </template>
            <template slot-scope="{row}" slot="filter">
                型号：{{row.lightfilterType}}<br>
                编号：{{row.lightfilterNo}}<br>
                厂家：{{row.lightfilterManu}}
            </template>-->

            <template slot-scope="{row}" slot="operation">
                <a class="opt-txt" @click="handleOperation(row,'NOADD')">添加编号</a>
                <a class="opt-txt" @click="handleOperation(row,'EDIT')">编辑</a>
                <a class="opt-txt" @click="handleOperation(row,'DELETE')">删除</a>
            </template>
        </Table>
        <page-model :paging="page" :total="total" @page-change="handlePageChange"></page-model>

        <instrument-edit v-model="modalVisible" :dataSource="modalData" @on-success="getTableData"></instrument-edit>
    </Card>
</template>
<script>
    import iExam from '@/module/main/api/iExam';
    import tableHelper from '@/mixins/tableHelper';
    import DepartSel from '@/module/main/components/DepartSel';
    import TesterSel from '@/module/main/components/TesterSel';
    import InstrumentEdit from '@/module/main/components/InstrumentEdit';
    import _don from '@/libs/doson'
    import * as _ from "lodash";
    import {instrumentType} from "@/config/config"

    export default {
        name: "archive_mng",
        mixins: [tableHelper],
        components: {
            DepartSel,TesterSel,InstrumentEdit
        },
        data() {
            return {
                query:{
                    department:{id:null},
                    tester:{id:null},
                    dataType:null
                },
                typeArr:instrumentType,
                //typeArr:[,'烟度计','计时器','震动转速分析仪','滤光片'],
                modeArr:[,'串口','蓝牙','WIFI'],
                tableColumns:[
                    {title: '序号', key: 'idx', width: 80},
                    {title: '检测单位', slot: 'department'},
                    {title: '检测员', slot: 'tester'},
                    {title: '设备类型', slot: 'dataType'},
                    {title: '通信方式', slot: 'communicationMode'},
                    {title: '型号', key: 'instrumentType'},
                    {title: '编号', key: 'instrumentNo'},
                    {title: '厂家', key: 'instrumentManu'},
                    {title: '计量证书', key: 'cmaNo'},
                    {title: '操作', slot: 'operation',width:200}
                ],

                modalTitle:'添加档案',
                modalVisible:false,
                modalData:{},

                reportVisible:false,
                equipId:0,

                checkVisible:false,
                receiveVisible:false,

                imgUrl:'',
                voucherShow:false,
            }
        },
        mounted() {
            this.getTableData()
        },
        methods: {
            getTableData() {
                iExam.instrumentList(this.page, this.query).then(res => {
                    var i = 1
                    this.tableList = res.content.map(e => {
                        e.idx = (this.page.page-1)*this.page.size+i++
                        return e
                    });
                    this.total = res.totalElements
                }).loadingSwitch(this, 'tableLoading');
            },
            async handleOperation(row, type) {
                if (type === 'ADD') {
                    this.modalData = {}
                    this.modalVisible = true
                    return;
                }
                if (type === 'NOADD') {
                    let instrument = _.cloneDeep(row)
                    instrument.id = null
                    instrument.instrumentNo = null
                    instrument.camNo = null
                    instrument.calibrationUtilDate = null
                    if (instrument.tester) {
                        instrument.tester.id = null;
                    }

                    this.modalData = instrument
                    this.modalVisible = true
                    return;
                }
                if (type === 'EDIT') {
                    this.modalData = row
                    this.modalVisible = true
                    return;
                }
                if (type === 'DELETE') {
                    this.$Modal.confirm({
                        title: '提示',
                        content: `是否删除该设备信息，确认继续？`,
                        onOk: () => {
                            iExam.instrumentDelete(row.id).then(() => {
                                this.$Message.success('操作成功');
                                this.getTableData();
                            }).loadingSwitch(this, 'tableLoading');
                        }
                    });
                    return;
                }
            },
            getTypeName(type) {
                let finded = this.typeArr.find(e=>e.value==type)
                if (finded) {
                    return finded.label
                }
                return '未知'
            }
        },
    }
</script>

<style scoped lang="less">

</style>
